export default "__VITE_ASSET__JvWEWO0e__"